module.exports = __webpack_public_path__ + "img/step9.cc46784c.png";